export const normalizeParameter = (value: string | undefined | null): string | undefined => {
  return !value || value === 'undefined' || value === 'null' ? undefined : value;
};
